import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {authenticated} from './reducers/auth'
//import getMuiTheme from './getMuiTheme';
let muiTheme = null;
let MuiThemeProvider = null
class ThemeProvider extends Component {
	static propTypes = {
		children: PropTypes.element,
    	muiTheme: PropTypes.object,
	}

	static childContextTypes = {
    	muiTheme: PropTypes.object,
	}
  	state = {
  		muiTheme: null
  	}
  	
  	getChildContext()
	{
    	    return {
        	muiTheme
    	    }
	}
  	
	componentWillMount() {
		const {isAuthenticating, authenticated} = this.props
		if(!muiTheme && isAuthenticating && !this.props.isAuthenticated) {
		    require.ensure('./admin/admin', () => {
      			muiTheme = require('./admin/admin').muiTheme;
      			MuiThemeProvider = require('./admin/admin').MuiThemeProvider
      			this.setState({muiTheme})
      			authenticated()
	    	});
		}
	}
	componentWillReceiveProps(nextProps) {
		const {isAuthenticating} = nextProps
		if(!muiTheme && isAuthenticating && !this.props.isAuthenticated) {
		    require.ensure('./admin/admin', () => {
      			muiTheme = require('./admin/admin').muiTheme;
       			MuiThemeProvider = require('./admin/admin').MuiThemeProvider
     			this.setState({muiTheme})
      			this.props.authenticated()
	    	});
		}
	}

  	render() {
  		const {muiTheme} = this.state
    	if (!muiTheme) return this.props.children;
    
    	return <MuiThemeProvider muiTheme={muiTheme}>{this.props.children}</MuiThemeProvider>
  	}
}

function mapStateToProps(state) {
	return {
		isAuthenticating: state.auth.isAuthenticating,
		isAuthenticated: state.auth.isAuthenticated
	}
}

export default connect(mapStateToProps, {authenticated})(ThemeProvider);



// WEBPACK FOOTER //
// ./src/fm/ThemeProvider.js